import { Gavel, Users, Trophy } from "lucide-react";

export default function Login() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-cream">
      <div className="mx-auto max-w-6xl px-6 pt-10 pb-16">
        <header className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-sunny border-2 border-black rounded-xl shadow-brut flex items-center justify-center">
              <Gavel strokeWidth={3} className="w-5 h-5" />
            </div>
            <span className="font-fredoka text-2xl font-bold">Ricky</span>
          </div>
          <button data-testid="login-google-btn-top" onClick={handleGoogle} className="brut-btn-white">
            Sign in with Google
          </button>
        </header>

        <section className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7">
            <h1 className="font-fredoka text-5xl sm:text-6xl lg:text-7xl font-bold leading-[0.95] tracking-tight">
              Skip the vote.<br/>
              <span className="bg-sunny border-2 border-black rounded-xl px-3 inline-block -rotate-1 shadow-brut">Bid</span> for what
              <br/>the family does next.
            </h1>
            <p className="mt-6 text-lg max-w-xl text-gray-800">
              Earn points for hosting great nights. Then bid them (sealed & second-price) to pick
              the movie, plan the trip, or decide dinner. No shouting matches. Just honest bids.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <button data-testid="login-google-btn" onClick={handleGoogle} className="brut-btn text-lg px-7 py-4">
                Sign in with Google
              </button>
              <a href="#how" className="brut-btn-mint text-lg px-7 py-4">How it works</a>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="brut-card p-0 overflow-hidden rotate-2">
              <img
                alt="family movie night"
                src="https://images.unsplash.com/photo-1665827491450-c6f329f2285c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxmYW1pbHklMjBtb3ZpZSUyMG5pZ2h0fGVufDB8fHx8MTc4Nzk0NTI2OHww&ixlib=rb-4.1.0&q=85"
                className="w-full h-80 object-cover"
              />
              <div className="p-4 border-t-2 border-black bg-lilac">
                <div className="font-fredoka font-bold">Family Movie Night</div>
                <div className="text-sm">3 bidders • closes in 2h 14m</div>
              </div>
            </div>
          </div>
        </section>

        <section id="how" className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: <Users strokeWidth={3} className="w-6 h-6"/>, title: "Join the family", body: "An admin sends you an invite code. Redeem it to receive a starting points allowance.", bg: "bg-mint" },
            { icon: <Gavel strokeWidth={3} className="w-6 h-6"/>, title: "Bid in secret", body: "Every auction is a sealed-bid Vickrey auction. Highest bid wins, but pays the second-highest price.", bg: "bg-peach" },
            { icon: <Trophy strokeWidth={3} className="w-6 h-6"/>, title: "Earn by hosting", body: "Run a great event? The admin marks it a success and you gain points to bid another day.", bg: "bg-sky" },
          ].map((c, i) => (
            <div key={i} className={`brut-card p-6 ${c.bg}`}>
              <div className="w-10 h-10 bg-white border-2 border-black rounded-lg flex items-center justify-center mb-3">{c.icon}</div>
              <h3 className="font-fredoka text-2xl font-bold">{c.title}</h3>
              <p className="mt-2 text-sm">{c.body}</p>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
